/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  ConsentDto,
  UpdateConsentsRequest
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getMeConsentsV1Response200 = {
  data: ConsentDto[]
  status: 200
}

export type getMeConsentsV1Response401 = {
  data: void
  status: 401
}

export type getMeConsentsV1ResponseSuccess = (getMeConsentsV1Response200) & {
  headers: Headers;
};
export type getMeConsentsV1ResponseError = (getMeConsentsV1Response401) & {
  headers: Headers;
};

export type getMeConsentsV1Response = (getMeConsentsV1ResponseSuccess | getMeConsentsV1ResponseError)

export const getGetMeConsentsV1Url = () => {




  return `/api/v1/me/consents`
}

/**
 * Returns all GDPR/marketing consents for the authenticated user.
 * @summary Get current user's consent preferences
 */
export const getMeConsentsV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getMeConsentsV1Response> => {

  return customFetch<getMeConsentsV1Response>(getGetMeConsentsV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type updateMeConsentsV1Response200 = {
  data: ConsentDto[]
  status: 200
}

export type updateMeConsentsV1Response400 = {
  data: void
  status: 400
}

export type updateMeConsentsV1Response401 = {
  data: void
  status: 401
}

export type updateMeConsentsV1ResponseSuccess = (updateMeConsentsV1Response200) & {
  headers: Headers;
};
export type updateMeConsentsV1ResponseError = (updateMeConsentsV1Response400 | updateMeConsentsV1Response401) & {
  headers: Headers;
};

export type updateMeConsentsV1Response = (updateMeConsentsV1ResponseSuccess | updateMeConsentsV1ResponseError)

export const getUpdateMeConsentsV1Url = () => {




  return `/api/v1/me/consents`
}

/**
 * Creates or updates the opt-in/out state for one or more consent types in a single batch. Returns the resulting consents.
 * @summary Update opt-in state for one or more consent types
 */
export const updateMeConsentsV1 = async (updateConsentsRequest: UpdateConsentsRequest, options?: Parameters<typeof customFetch>[1]): Promise<updateMeConsentsV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<updateMeConsentsV1Response>(getUpdateMeConsentsV1Url(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateConsentsRequest)
  }
);}


